import React, { useEffect, useRef, useState } from 'react';

export const useScrollDirection = (ref: React.RefObject<HTMLElement>) => {
  const timerRef = useRef<NodeJS.Timeout>();

  const [isScrolling, setScrolling] = useState<boolean>(false);
  const [scrollDirection, setScrollDirection] = useState<'down' | 'up'>();

  useEffect(() => {
    const toggleScrollDirection = (event: WheelEvent) => {
      setScrolling(true);

      if (!event.deltaX && event.deltaY < 0) {
        setScrollDirection('up');
      } else if (!event.deltaX && event.deltaY > 0) {
        setScrollDirection('down');
      }

      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setScrolling(false);
      }, 200);
    };

    const element = ref.current;
    if (!element) return;

    element.addEventListener('wheel', toggleScrollDirection);
    return () => {
      element.removeEventListener('wheel', toggleScrollDirection);
    };
  }, []); // intentional missing deps

  return {
    isScrolling,
    scrollDirection,
  };
};
